export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))
